import { render, staticRenderFns } from "./general-no-access.vue?vue&type=template&id=1e6b1ace&scoped=true&"
import script from "./general-no-access.vue?vue&type=script&lang=ts&"
export * from "./general-no-access.vue?vue&type=script&lang=ts&"
import style0 from "./general-no-access.vue?vue&type=style&index=0&id=1e6b1ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6b1ace",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
